import type { Page } from '../../types';

const fraudInvestigations: Page[] = [
  {
    pageType: 'question',
    title: 'Fraud Investigations',
    name: 'fraud-investigations-declare',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you have any instances of fraud investigations to declare?',
        name: 'fraud_investigations_declare',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'Fraud Investigations',
    name: 'fraud-investigations',
    type: 'nilreturn',
    fastToggle: true,
    disabled: [
      {
        field: 'fraud_investigations_declare',
        condition: 'equals',
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'instanceInput',
        title: 'How many investigations were brought forward?',
        name: 'fraud_investigations_forward',
        hint: 'Total number of instances',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'instanceInput',
        title: 'How many investigations were opened?',
        name: 'fraud_investigations_opened',
        hint: 'Total number of instances',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'instanceInput',
        title: 'How many investigations were closed?',
        name: 'fraud_investigations_closed',
        hint: 'Total number of instances',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'instanceInput',
        title: 'How many investigations were ongoing?',
        name: 'fraud_investigations_ongoing',
        hideOptionalLabel: true,
        hint: 'Total number of instances',
        rules: {
          required: true,
        },
        autofillMath: {
          expression: 'a + b - c',
          fields: {
            a: 'fraud_investigations_forward',
            b: 'fraud_investigations_opened',
            c: 'fraud_investigations_closed',
          },
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'fraud_investigations_comments',
        hint: 'Please ensure you do not include any personal or sensitive information',
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default fraudInvestigations;




